import Swal from 'sweetalert2';
import { onToastBodyHtml } from './_ToastBody';
import { onPositionSwal } from './_toastPosition';

/*
    🔥 TOAST — sweetalert2 en modo toast

    No acepta JSX, así que usa la versión HTML del mismo cuerpo.
    Mismas clases, mismo resultado visual que las otras cinco.

    No necesita Host: se monta y desmonta solo.
*/

export const AlertSweetAlertHost = () => null;

export const onNotifySweetAlert = ({ type = 'info', title, text, autoClose, position }) => (

    Swal.fire({
        toast: true, position: onPositionSwal(position),
        html: onToastBodyHtml({ type, title, text }), showConfirmButton: false,
        showCloseButton: false, timer: autoClose || 4000,
        width: 'auto', padding: 0, background: 'transparent',
        backdrop: false, customClass: { container: 'LStudio__app_toast_swal_container', popup: 'LStudio__app_toast_swal' },
    })
);
